import React from 'react';
import {
    IconWorld,
    IconFlag,
    IconMap,
    IconBuilding,
    IconAlertTriangle,
    IconHistory,
    IconEyeOff,
    IconHandStop,
    IconHeartHandshake,
    IconHelp,
    IconEar,
    IconFish,
    IconBulb,
    IconQuestionMark,
    IconSwords,
    IconBomb,
    IconBowl,
    IconDropletOff,
    IconCoinOff,
    IconHandOff,
    IconShieldCheck,
    IconScale,
    IconTemperature,
    IconCircleDot,
    IconHourglassHigh,
    IconCircleCheck,
    IconCircleOff,
    IconEye,
    IconMedicalCross,
    IconWeight,
    IconMicroscope,
    IconHomeOff,
    IconBook,
    IconCloudStorm,
    IconUsersGroup,
    IconGavel,
    IconPill,
    IconGlobe,
    IconTrash,
    IconWheelchair,
    IconBabyCarriage
} from '@tabler/icons-react';

// Icon mapping for action tags
export const actionTagIcons = {
    massacre: <IconAlertTriangle size={28} color="#e74c3c" />,
    history: <IconHistory size={28} color="#3498db" />,
    truth: <IconEyeOff size={28} color="#8e44ad" />,
    fault: <IconHandStop size={28} color="#e67e22" />,
    contribution: <IconHeartHandshake size={28} color="#27ae60" />,
    anyone: <IconHelp size={28} color="#f39c12" />,
    rockears: <IconEar size={28} color="#7f8c8d" />,
    goldfish: <IconFish size={28} color="#3498db" />,
    solution: <IconBulb size={28} color="#f1c40f" />,
    whatif: <IconQuestionMark size={28} color="#9b59b6" />
};

// Icon mapping for scale options
export const scaleOptionIcons = {
    global: <IconWorld size={24} color="#2c3e50" />,
    national: <IconFlag size={24} color="#e74c3c" />,
    state: <IconMap size={24} color="#e67e22" />,  // Orange color for state/regional
    local: <IconBuilding size={24} color="#95a5a6" />  // Gray color for local
};

// Icon mapping for issues
export const issueIcons = {
    violence: <IconSwords size={18} color="#e74c3c" />,
    war: <IconBomb size={18} color="#e74c3c" />,
    hunger: <IconBowl size={18} color="#f39c12" />,
    water_scarcity: <IconDropletOff size={18} color="#3498db" />,
    poverty: <IconCoinOff size={18} color="#27ae60" />,
    exploitation: <IconHandOff size={18} color="#e67e22" />,
    safety: <IconShieldCheck size={18} color="#2ecc71" />,
    corruption: <IconScale size={18} color="#8e44ad" />,
    climate_change: <IconTemperature size={18} color="#7f8c8d" />,
    health: <IconMedicalCross size={18} color="#e74c3c" />,
    'food-insecurity': <IconBowl size={18} color="#f39c12" />,
    obesity: <IconWeight size={18} color="#8e44ad" />,
    disease: <IconMicroscope size={18} color="#e74c3c" />,
    'food-waste': <IconTrash size={18} color="#7f8c8d" />,
    homelessness: <IconHomeOff size={18} color="#8e44ad" />,
    education: <IconBook size={18} color="#3498db" />,
    'natural-disasters': <IconCloudStorm size={18} color="#e67e22" />,
    racism: <IconUsersGroup size={18} color="#e74c3c" />,
    crime: <IconGavel size={18} color="#e74c3c" />,
    'substance-abuse': <IconPill size={18} color="#8e44ad" />,
    refugee: <IconGlobe size={18} color="#3498db" />,
    pollution: <IconTrash size={18} color="#7f8c8d" />,
    disability: <IconWheelchair size={18} color="#27ae60" />,
    'child-labor': <IconBabyCarriage size={18} color="#e67e22" />,
    'human-trafficking': <IconBuilding size={18} color="#e74c3c" />,
};

// Icon mapping for issue statuses
export const issueStatusIcons = {
    unresolved: <IconAlertTriangle size={18} color="#f59e0b" />,
    neutral: <IconCircleDot size={18} color="#6b7280" />,
    open: <IconCircleDot size={18} color="#4caf50" />,
    in_progress: <IconHourglassHigh size={18} color="#2196f3" />,
    resolved: <IconCircleCheck size={18} color="#22c55e" />,
    closed: <IconCircleOff size={18} color="#f44336" />,
    monitoring: <IconEye size={18} color="#9e9e9e" />,
};
